<template>
  <v-container>
    <v-expansion-panels>
      <v-expansion-panel v-for='(row,index) in 問い合わせrtn' :key='index'>
        <v-expansion-panel-title>{{row.タイトル}} {{row.名前}}（{{row.created_at}}）</v-expansion-panel-title>
        <v-expansion-panel-text>
          {{row.メールアドレス}}<br>
          {{row.created_at}}<br>
          <span v-html='row.内容'></span>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <!--
    <v-list v-for='(row,index) in 問い合わせrtn' :key='index'>
      <v-list-item>
        <v-list-item-title>{{row.名前}}</v-list-item-title>
        <v-list-item-subtitle>{{row.created_at}}</v-list-item-subtitle>
      </v-list-item>
    </v-list>
    -->
  </v-container>
</template>
<script>
export default {
  data(){
    return {
      問い合わせrtn:[],
    }
  },

  mounted(){
    this.問い合わせ取得();
  },

  methods:{
    問い合わせ取得(){
       this.$emit('overlay');

        let url = '../api/api.php';
        let data = {
          func:"問い合わせ取得",
          limit:99999,
        };

        let param = {
            method : "POST",
            headers : { "Content-Type": "application/json" },
            body : JSON.stringify(data),
            }
        fetch(url,param)
        .then(response => {return response.text();})
        .then(result => {
          try {
            const jsonData = JSON.parse(result);
            return jsonData;
          }catch(e){
            return Promise.reject({body:result,type:'unparsable'})
          }
        })
        .then(result => {
          this.問い合わせrtn = result.問い合わせrtn;
          this.$emit('overlay');
          this.名前 = ""
          this.メールアドレス = ""
          this.タイトル = ""
          this.内容 = "";
        })
        .catch(error =>{
          console.log(error)
          alert('取得できませんでした。\n\n'+error.body);
          this.$emit('overlay');
        })
    }
  },


}
</script>
